import profileImage from '../../assets/images/mahi.jpg';

export const testimonials = [
  {
    name: 'Mahi',
    job: 'SMM @ The Influence Agency',
    testimonial: `I'm a social media manager and EnhanceAI truly made me work so much
    faster! There have been too many times where I've spent WAY too much
    time on a post caption, trying to think of a unique, witty or
    un-repetitive starting sentence (which can get a little frustrating/and
    time consuming). Having something to help with caption writing really
    helps me be more efficient and helps me complete my work A LOT quicker!
    There is even an option where you can pick the tone of a caption, which
    is really helpful when a brand has a specific brand tone you need to
    follow! This has truly been a life-saver!`,
    image: profileImage,
  },
  {
    name: 'Wani Zuka',
    job: 'Marketing Manager',
    testimonial: `Thank you for making my life as a marketing manager/ and creative director so much easier! Because of enhance AI i use my time so effectively!`,
    image: '',
  },
];
